import { defineStore } from "pinia";
import { teamUser,teamInfo,withdrawBalance } from "@/api/invite"
export const useInviteStore = defineStore({
  id: "invite",
  state: () => ({
    inviteShow:false,
    inviteTipDialogFlag:false,
    quitMemberItem:'levelOne',
    teamUserList:[],
    memberList:[],
    teamInfo:{},
    withdrawBalanceDate:{},
    teamUserParmas:{
      level:'1',
      page:1,
      limit:10,
    },
  }),
  actions: {
    getWithdrawBalance() {
      withdrawBalance().then(res=>{
        this.withdrawBalanceDate = res.data
      })
    },
    getTeamInfo() {
      teamInfo().then((res) => {
        this.teamInfo = res.data;
      });
    },
    getTeamUserList(){
      teamUser(this.teamUserParmas).then(res=>{
        this.teamUserList = res.data.data
      })
    },
    setInviteShow(e){
      this.inviteShow = e
    },
    setInviteTipDialogFlag(e) {
      this.inviteTipDialogFlag = e
    },
    setQuitMemberItem(e) {
      this.teamUserParmas.level = e ==='levelOne'?'1':'2'
      this.teamUserParmas.page = 1
      this.getTeamUserList()
      this.quitMemberItem = e
      this.getTeamInfo()
    },
    addMemberList(e) {
      this.memberList.push(...e)
    },
    clearMemberList() {
      this.memberList = []
    }
  },
});
